
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { PERMISSION } from '@/permissions';
import PromoCode from '@/components/orders/modals/form/discount/PromoCode.vue';
import ManualDiscount from '@/components/orders/modals/form/discount/ManualDiscount.vue';

@Component<DiscountInformation>({
	components: {
		PromoCode,
		ManualDiscount
	}
})
export default class DiscountInformation extends Vue {
	@Prop({ type: String, required: true }) private orderType!: StaffOrderingType;
	@Getter('getDiscountInfo', { namespace: 'orders' }) private promoDiscountInfo!: CostsDiscount | null;
	@Getter('getDiscounts', { namespace: 'auth' }) private discounts!: DiscountInfo;
	@Getter('hasPermission', { namespace: 'auth' }) private hasPermission!: (permission: PERMISSION) => boolean;

	private discountTab: number = 0;

	private get isPromoCodeApplied(): boolean {
		return !!(this.promoDiscountInfo?.code);
	}

	private get isManualDiscountApplied(): boolean {
		return !!(this.promoDiscountInfo && this.promoDiscountInfo.amount && this.promoDiscountInfo.manual);
	}

	private get displayMode(): 'code' | 'manual' | 'code_and_manual' {
		if (this.orderType === 'generic-catering' && this.hasPermission(PERMISSION.ORDER_CATERING_DISCOUNT)) {
			if (this.discounts.codes?.length || (this.promoDiscountInfo && this.promoDiscountInfo.code && this.promoDiscountInfo.amount > 0)) {
				return 'code_and_manual';
			}
			return 'manual';
		}
		return 'code';
	}

	private created(): void {
		if (this.isPromoCodeApplied) {
			this.discountTab = 1;
		}
	}
}
